import { Pipe, PipeTransform } from '@angular/core';
import { RecentRoute } from '../recent-routes/models/RecentRoutes';

@Pipe({
  name: 'recentFilterPipe',
})
export class RecentFilterPipe implements PipeTransform {
  transform(recents: RecentRoute[], showMore: boolean): RecentRoute[] {
    return recents ? (showMore ? [...recents] : [...recents].slice(0, 10)) : [];
  }
}
